import { useMemo, useState } from 'react';

// Components
import SupportModal from '../../components/SupportModal';

interface OnboardingProgressProps {
  steps: {
    label: string;
    path: string;
  }[];
  currentStep: number;
}

function OnboardingProgress({ steps, currentStep }: OnboardingProgressProps) {
  const [showModal, setShowModal] = useState(false);

  // "Progress Bar" increments
  const renderedSteps = useMemo(
    () =>
      steps.map((step, index) => (
        <li
          key={index}
          className="relative flex flex-col flex-1 whitespace-nowrap"
        >
          <div className="flex items-center">
            <div
              className={`h-4 w-4 rounded-full bg-light ${index + 1 === currentStep
                  ? 'border-2 border-success'
                  : index + 1 < currentStep
                    ? 'bg-success'
                    : ''
                }`}
            ></div>
            <span
              className={`ml-4 leading-none ${index + 1 >= currentStep
                  ? 'text-light font-medium'
                  : 'text-success  font-medium'
                }`}
            >
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 ? (
            <div
              className={`flex-1 w-[1px] ms-2 ${index + 1 >= currentStep ? 'bg-light' : 'bg-success'
                }`}
            ></div>
          ) : null}
        </li>
      )),
    [steps, currentStep]
  );

  return (
    <div className="fixed top-0 right-0 h-full w-[280px] z-[60] bg-secondarygray text-light flex flex-col justify-between rounded-bl-3xl">
      {showModal ? <SupportModal onClose={() => setShowModal(false)} /> : null}
      <div className="w-full flex items-center justify-between p-0 m-0 bg-transparent relative">
        <div className="relative w-full mr-5">
          <img
            src={`${process.env.PUBLIC_URL}/static/img/Logo.svg`}
            alt="Logo"
            className="absolute top-[17px] right-[20px] z-[100] w-[123px] h-[20px] flex-shrink-0"
          />
          <div className="absolute top-0 right-[-20px] w-[280px] mb-[-20px] z-[1]">
            <img
              src={`${process.env.PUBLIC_URL}/static/img/Exclude_new.svg`}
              alt="Vector"
              className="w-full h-full scale-x-[-1]"
            />
          </div>
        </div>
      </div>
      <div className="mt-[91px] px-6 flex-1 font-medium relative">
        <p className="text-light text-2xl font-bold">Onboarding</p>

        {/* --- Progress --- */}
        <ul className="flex flex-col h-[calc(100%-40px)] pt-5">
          {renderedSteps}
        </ul>
      </div>
      <div className="flex flex-col justify-center items-center gap-4 px-4 mb-6 text-sm text-light">
        <p>
          Need help?{' '}
          <span
            className="underline cursor-pointer"
            onClick={() => setShowModal(true)}
          >
            Connect with support
          </span>
        </p>
      </div>
    </div>
  );
}

export default OnboardingProgress;
